import { IExportColumnModel } from "../../../../../shared/models";

export const InboundFilesColumnList: IExportColumnModel[] = [
]